import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.app;

export const appTitleSelector = createSelector(getState, (state) => state.appTitle);

export const subscriptionsSelector = createSelector(getState, (state) => state.subscriptions);
export const isLoadingSubscriptionsSelector = createSelector(
  getState,
  (state) => state.isLoadingSubscriptions
);
